<template>
	<div class="cms-video-embed-block">
		<div v-if="embedUrl" class="cms-video-embed-block__wrapper">
			<iframe
				:src="embedUrl"
				class="cms-video-embed-block__iframe"
				frameborder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowfullscreen
			></iframe>
		</div>
		<div v-else class="cms-video-embed-block__placeholder">
			<i class="fa fa-play-circle"></i>
			<span>No video URL set</span>
		</div>
	</div>
</template>

<script>
/**
 * VideoEmbedBlock.vue
 * ───────────────────
 * Embeds a YouTube or Vimeo video via an iframe with responsive 16:9 ratio.
 * Width, alignment and spacing are wrapper style traits; the block fills
 * the wrapper width.
 */

export default {
	name: 'VideoEmbedBlock',

	props: {
		url: { type: String, default: '' }
	},

	computed: {
		embedUrl: function () {
			if (!this.url) return '';
			var u = this.url;

			// YouTube: convert watch URLs to embed (IDs are 11 chars)
			var ytMatch = u.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
			if (ytMatch) return 'https://www.youtube.com/embed/' + ytMatch[1];

			// Vimeo: convert standard URLs to embed
			var vmMatch = u.match(/vimeo\.com\/(\d{1,12})/);
			if (vmMatch) return 'https://player.vimeo.com/video/' + vmMatch[1];

			// Only allow URLs that start with https://
			if (/^https:\/\//i.test(u)) return u;

			return '';
		}
	}
};
</script>

<style scoped>
.cms-video-embed-block { width: 100%; max-width: 100%; }
.cms-video-embed-block__wrapper {
	position: relative; width: 100%; padding-bottom: 56.25%; height: 0; overflow: hidden;
	border-radius: 4px;
}
.cms-video-embed-block__iframe {
	position: absolute; top: 0; left: 0; width: 100%; height: 100%;
}
.cms-video-embed-block__placeholder {
	display: flex; flex-direction: column; align-items: center; justify-content: center;
	width: 100%; min-height: 120px; background: #F4F4F5; border: 2px dashed #DDDEE0;
	border-radius: 4px; color: #999; gap: 0.5rem;
}
.cms-video-embed-block__placeholder .fa { font-size: 2.5em; }
</style>
